import GlobalSearch from './global-search.vue'

export default {
  'global-search': GlobalSearch
}
